(function () {
  "use strict";

  function initImageLinkBlocks() {
    if (window.innerWidth > 749) return;

    const sections = document.querySelectorAll(
      ".shopify-section--image-link-blocks"
    );

    sections.forEach(function (section) {
      const container = section.querySelector('[id^="scroll-area-"]');
      if (!container) return;

      const mobileRows = parseInt(
        container.getAttribute("data-mobile-rows") || "2"
      );
      const itemsPerRow = 2;
      const maxVisibleItems = mobileRows * itemsPerRow;
      const allItems = container.querySelectorAll(
        ".image-link-blocks__item[data-item-index]"
      );

      if (allItems.length <= maxVisibleItems) return;

      allItems.forEach(function (item, index) {
        if (index >= maxVisibleItems) {
          item.classList.add("hidden-item");
        }
      });

      const toggleButtonWrapper = section.querySelector(
        "[data-button-wrapper]"
      );
      if (!toggleButtonWrapper) {
        console.warn(
          'View More button not found. Please add "View More Button" block in the section.'
        );
        return;
      }

      const toggleButton = toggleButtonWrapper.querySelector("button");
      if (!toggleButton) return;

      toggleButton.setAttribute("data-action", "toggle-rows");
      toggleButton.setAttribute(
        "data-view-more",
        toggleButtonWrapper.getAttribute("data-view-more")
      );
      toggleButton.setAttribute(
        "data-view-less",
        toggleButtonWrapper.getAttribute("data-view-less")
      );
      toggleButton.classList.add("image-link-blocks__toggle-button");

      const viewMoreText = toggleButton.getAttribute("data-view-more");
      const viewLessText = toggleButton.getAttribute("data-view-less");

      toggleButton.addEventListener("click", function () {
        if (container.classList.contains("is-expanded")) {
          allItems.forEach(function (item, index) {
            if (index >= maxVisibleItems) {
              item.classList.add("hidden-item");
            }
          });
          container.classList.remove("is-expanded");
          toggleButton.textContent = viewMoreText;
        } else {
          allItems.forEach(function (item) {
            item.classList.remove("hidden-item");
          });
          container.classList.add("is-expanded");
          toggleButton.textContent = viewLessText;
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initImageLinkBlocks);
  } else {
    initImageLinkBlocks();
  }

  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      if (event.detail.sectionId && event.detail.container) {
        const section = event.detail.container.querySelector(
          ".shopify-section--image-link-blocks"
        );
        if (section) {
          initImageLinkBlocks();
        }
      }
    });
  }
})();
